import Heading from "shared/ui/typography/Heading";
import Text from "shared/ui/typography/Text";
import { concatClassnames } from "shared/utils/concatClassnames";

export enum PaymentHeaderTypes {
  REMAINING_PAYMENT,
  ALL_PAYMENTS,
  CUSTOM_PAYMENT,
  STANDARD_PRODUCT_PAYMENT,
}

const PAYMENT_HEADER_TEXT_MAP: Record<
  PaymentHeaderTypes,
  { title: string; description: string }
> = {
  // TODO: Add PaymentHeaderType for panel payment
  [PaymentHeaderTypes.REMAINING_PAYMENT]: {
    title: "Ben je klaar om resterende bedrag te betalen?",
    description: `Er is een gerse blikvanger bij je geleverd! We zien dat er nog een restant bedrag openstaat. Dit kun 
      je hieronder direct betalen.`,
  },
  [PaymentHeaderTypes.ALL_PAYMENTS]: {
    title: "Leuk dat je kiest voor GewoonGers",
    description: `Leuk dat wij je bestelling voor je mogen verzorgen! Om je bestelling compleet te maken, dient er een 
    betaling te worden gedaan. Kies uit één van onderstaande opties om verder te gaan:`,
  },
  [PaymentHeaderTypes.CUSTOM_PAYMENT]: {
    title: "Gefeliciteerd met jouw nieuwe GewoonGers-deur!",
    description:
      "We hopen dat je helemaal tevreden bent en bieden op deze pagina de mogelijkheid om te betalen.",
  },
  [PaymentHeaderTypes.STANDARD_PRODUCT_PAYMENT]: {
    title: "Leuk dat wij je bestelling voor je mogen verzorgen! ",
    description: `Om je bestelling compleet te maken, dient er een betaling te worden gedaan. 
    Kies uit één van onderstaande opties om verder te gaan:`,
  },
};

interface PaymentHeaderProps {
  className?: string;
  type: PaymentHeaderTypes;
  isZakelijk?: boolean;
}

const PaymentHeader = ({
  className,
  type,
  isZakelijk = false,
}: PaymentHeaderProps) => {
  if (isZakelijk)
    return (
      <header className={concatClassnames(className)}>
        <Heading headingLevel="h2" className="gg-mb-3">
          Bedankt dat je voor GewoonGers hebt gekozen.
        </Heading>

        <Text>
          Leuk dat wij je bestelling voor je mogen verzorgen! Kies uit één van
          onderstaande opties om verder te gaan:
        </Text>
      </header>
    );

  return (
    <header className={concatClassnames(className)}>
      <Heading headingLevel="h2" className="gg-mb-3">
        {PAYMENT_HEADER_TEXT_MAP[type].title}
      </Heading>

      <Text>{PAYMENT_HEADER_TEXT_MAP[type].description}</Text>
    </header>
  );
};
export default PaymentHeader;
